import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-age',
  templateUrl: './alert-age.component.html',
  styleUrls: ['./alert-age.component.scss']
})
export class AlertAgeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
